import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

export const Container = styled.section(
    ({ theme }) => css`
        background: ${theme.colors.white};
        width: 100%;
        padding: ${theme.spacing.xLarge} 0;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            width: 100vw;
            margin-left: 50%;
            transform: translateX(-50%);
            position: relative;
        }
    `,
)

export const InnerContainer = styled.div(
    ({ theme }) => css`
        max-width: 82.75rem;
        margin: 0 auto;
        padding: 0 ${theme.spacing.large};

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 0 ${theme.spacing.large};
        }
    `,
)

export const QuoteContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: ${theme.spacing.medium};
        padding: ${theme.spacing.medium} 0;
    `,
)

export const QuoteIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 2.5rem;
        height: 2.5rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            width: 3rem;
            height: 3rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            width: 3.5rem;
            height: 3.5rem;
        }
    }
`

export const QuoteText = styled.blockquote(
    ({ theme }) => css`
        margin: 0;
        font-weight: 500;
        font-size: ${theme.typography.font.size.medium};
        line-height: 1.4;
        text-align: center;
        color: #8055c2;
        max-width: 50rem;

        &::before,
        &::after {
            content: '"';
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.large};
            line-height: 1.5;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: 1.5625rem;
            line-height: 1.875rem;
        }
    `,
)
